import * as Yup from "yup";

export const UserCreateValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(2, "First Name should have at least 2 characters.")
    .max(50, "First Name cannot be more than 50 characters long.")
    .required("First Name is required"),
  lastName: Yup.string()
    .min(2, "Last Name should have at least 2 characters.")
    .max(50, "Last Name cannot be more than 50 characters long.")
    .required("Last Name is required"),
  email: Yup.string()
    .email("Invalid email")
    .required("Email is required"),
  password: Yup.string()
    .min(8, "Password is too short - should be 8 chars minimum.")
    .required("Password is required"),
  roleIDs: Yup.array().required("At least one role is required")
});

export const UserUpdateValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(2, "First Name should have at least 2 characters.")
    .max(50, "First Name cannot be more than 50 characters long.")
    .required("First Name is required"),
  lastName: Yup.string()
    .min(2, "Last Name should have at least 2 characters.")
    .max(50, "Last Name cannot be more than 50 characters long.")
    .required("Last Name is required"),
  roleIDs: Yup.array().required("At least one role is required")
});
